import { Component } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { InlineActionButtonComponent } from 'libs/ui/src/lib/inline-action-button/inline-action-button.component';
import { ProductLossDataGridService } from './product-loss-data-grid.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { Subscription, catchError, of, take } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import {
  customDecode,
  customEncode,
  decrypt,
  encrypt,
  greaterThanZeroValidator,
} from 'libs/shared/src/lib/service/helper.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProjectsFacade } from '@piqet-angular/data';
import { GridCellRendererComponent } from 'libs/ui/src/lib/grid-cell-renderer/grid-cell-renderer.component';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { AccessPermissionService, FeatureCodes } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-product-loss',
  templateUrl: './product-loss.component.html',
  styleUrls: ['./product-loss.component.scss'],
})
export class ProductLossComponent {
  FeatureCodes = FeatureCodes;
  disableSubmit: boolean = false;
  unitList = [];
  headerData = { title: '' };
  activatedRoute: string | undefined;
  subTitleText!: string;
  isSectorBased!: boolean;
  prodMixDataError = '';
  scenarioId!: number;
  colDefs!: ColDef[];
  frameworkComponents = {
    inlineActionButtonComponent: InlineActionButtonComponent,
    GridCellRendererComponent: GridCellRendererComponent,
  };
  sectorBasedLossData?: any;
  productLossBasedOnSectForm!: FormGroup;
  productGridForm: any;
  selectedUnit!: any;
  submitted: boolean = false;
  packageScenarioId!: number;
  productDetailsProductList: any;
  productDetailsData: any = [];
  isRowEditable: boolean = false;
  prodMixError!: Subscription;
  prodMixErrorStr!: Subscription;
  error: any;
  activatedRouteProjectId: any;
  selectedIdentifier!: any;
  isProdMixDisabled!: boolean;
  packagingProjectMenu!: Subscription;
  menuDataForRouting: any;
  nextRoute: any;
  eId: any;
  encodedUrl: string = 'true';
  backRouteType: any;
  submitForProduct = false;
  inlineGridDataSubscription!: Subscription;
  editProductSub!: Subscription;
  inlineEditingProductDeleteData!: Subscription;
  clearDeleteProductData!: Subscription;
  isCheckProductUpdate = false;
  exitsProductData: any;
  productDescription = '';
  hideShowAddSectionFlag = false;
  showEdit: boolean = true;
  navigationConfig: any;
  constructor(
    private productLossDataGridService: ProductLossDataGridService,
    public route: ActivatedRoute,
    private accessService: AccessPermissionService,
    private projectsService: ProjectsService,
    private toaster: ToastrService,
    private fb: FormBuilder,
    public projectsFacade: ProjectsFacade,
    public sharedService: SharedService,
    private router: Router
  ) {
    this.encodedUrl = customEncode(btoa(this.encodedUrl));
  }

  ngOnInit() {
    const url = location.href.split('/');
    this.triggerScroll();
    this.showEdit = this.accessService.hasPermission('edit', this.activatedRoute, 'packaging');
    this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    this.route.queryParams.subscribe((values: any) => {
      this.activatedRoute = this.route.snapshot.routeConfig?.path;
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
      this.packageScenarioId = value['packageScenarioId'];
      this.eId = value['eId'];
      this.navigationConfig = {
        scenarioId: this.scenarioId,
        packageScenarioId: this.packageScenarioId,
        eId: this.eId,
        activatedRouteProjectId: this.activatedRouteProjectId,
        activatedRoute: this.activatedRoute,
        isProductPage: false,
      };
      this.projectsFacade.clearProductMixList();
      this.projectsFacade.clearProductMixError('');
      this.getInitialData();
      this.getTitleTextValues(this.isSectorBased);
      this.isSectorBased && this.getSectorData();

      !this.isSectorBased && this.activatedRoute == 'product-loss-sector' && this.getSectorData();
      !this.isSectorBased && this.activatedRoute == 'product' && this.getProductDetails();
      this.initializeForm();
    });

    this.prodMixError = this.projectsFacade.productMixErrorStr$.subscribe((error: any) => {
      this.checkValidation(error);
      this.error = error;
    });

    this.packagingProjectMenu = this.sharedService.menuData$.subscribe((res: any) => {
      this.menuDataForRouting = res;
    });

    this.sharedService.disableAddRowBtnTrigger$.subscribe((error: any) => {
      this.checkEditingStatus(error);
    });

    this.inlineGridDataSubscription =
      this.productLossDataGridService.inlineEditingProductSaveData$.subscribe((data: any) => {
        this.projectsFacade.productMixList$.pipe(take(1)).subscribe((res: any) => {
          this.addProductGridData(res);
        });
      });
    this.editProductSub = this.productLossDataGridService.editProductSub$.subscribe((data: any) => {
      this.hideShowAddSectionFlag = true;
      this.isCheckProductUpdate = data[1];
      this.exitsProductData = data[0];
      this.productDescription = data[0].description;
      this.productGridForm.patchValue({ productDropDown: data[0].productId });

      this.productGridForm.controls['productDescription'].setValue(data[0].description);
      this.productGridForm.controls['productRatio'].setValue(data[0].ratio);
      this.sharedService.triggerScrollToBottom();
    });
    this.inlineEditingProductDeleteData =
      this.productLossDataGridService.inlineEditingProductDeleteData$.subscribe((data: any) => {
        this.deleteInlineData(data);
      });
    this.clearDeleteProductData = this.productLossDataGridService.clearInputFieldProduct$.subscribe(
      (check: any) => {
        this.productGridForm.controls['productDropDown'].setValue(null);
        this.productGridForm.controls['productDescription'].setValue(null);
        this.productGridForm.controls['productRatio'].setValue(null);
        this.isCheckProductUpdate = false;
      }
    );
  }
  deleteInlineData(data: any) {
    this.projectsService.deleteProductPackageScenarioDetail(data?.id).subscribe(res => {
      if (!res.messageType) {
        this.getProductDetails();
        this.toaster.success(res.message);
      } else {
        this.toaster.error(res.message);
      }
    });
  }

  initializeForm() {
    this.productLossBasedOnSectForm = this.fb.group({
      prodSectorData: { value: '', disabled: true },
      mass: ['', [Validators.required, Validators.maxLength(50), greaterThanZeroValidator()]],
      unit: [null, Validators.required],
      funcUnitMultiplier: ['', [Validators.required, greaterThanZeroValidator()]],
      sectorIdentier: [null],
      bulkDensity: ['', [Validators.required, greaterThanZeroValidator()]],
      retailVolume: [''],
    });
    this.productGridForm = this.fb.group({
      productDropDown: [null, [Validators.required]],
      productDescription: [null],
      productRatio: [null, [Validators.required, greaterThanZeroValidator()]],
    });
  }

  changeProductDes(event: any) {
    if (event?.idLong) {
      this.prodMixDataError = '';
      this.productDescription = event?.description;
      this.productGridForm.controls['productDescription'].setValue(event?.description);
    }
  }

  addProductGridData(productList: any) {
    this.submitForProduct = true;
    if (this.productGridForm.invalid) return;
    const productIdStr = this.productGridForm.value.productDropDown;
    const updatingIndex = this.isCheckProductUpdate ? this.exitsProductData.index : -1;
    const currentRatio = this.productGridForm.value?.productRatio;
    const duplicateProduct = productList.find((product: any, index: number) => {
      return product.productId === Number(productIdStr) && index + 1 !== updatingIndex;
    });
    this.sharedService.triggerScrollToBottom();
    if (duplicateProduct) {
      // Display error message or set error flag
      this.prodMixDataError = 'Product is already exists.';
      this.submitForProduct = false;
      return;
    }

    // Calculate the total ratio including the current ratio value
    const totalRatio =
      productList.reduce((total: number, product: any, index: number) => {
        if (index + 1 !== updatingIndex) {
          return total + product.ratio;
        }
        return total;
      }, 0) + currentRatio;

    if (totalRatio > 100) {
      // Display error message or set error flag
      this.prodMixDataError =
        'Please fill out the mandatory information to proceed. Product ratio (%) must amount to 100%.';
      this.submitForProduct = false;
      return;
    }
    const productDrpValue = this.productGridForm.value.productDropDown;
    const productData: any = {};
    const childItemsList = this.productDetailsProductList
      .map((item: any) => item.childItems)
      .flat();
    productData['name'] = childItemsList.find((x: any) => x.idLong == productDrpValue)?.name;
    productData['productId'] = Number(this.productGridForm.value.productDropDown);
    productData['ratio'] = this.productGridForm.value?.productRatio;
    productData['description'] = this.productGridForm.value?.productDescription?.trim();
    productData['scenarioId'] = this.scenarioId;
    productData['packageScenarioId'] = this.packageScenarioId;
    productData['id'] = 0;
    productData['isDescriptionChanged'] =
      this.productDescription == this.productGridForm.value?.productDescription?.trim()
        ? false
        : true;
    if (this.isCheckProductUpdate) {
      productData['index'] = this.exitsProductData.index;
      productData['id'] = this.exitsProductData.id;
      this.hideShowAddSectionFlag = false;
    }
    this.projectsFacade.updateProductMixAction(
      productData,
      this.isCheckProductUpdate ? 'edit' : 'add'
    );
    this.projectsService.addUpdateProductMixItem(productData).subscribe(res => {
      if (!res.messageType) {
        this.getProductDetails();
        this.toaster.success(res.message);
      } else {
        this.toaster.error(res.message);
      }
    });
    this.submitForProduct = false;
    this.isCheckProductUpdate = false;
    this.prodMixDataError = '';
    this.productDescription = '';
    this.productGridForm.controls['productDropDown'].reset();
    this.productGridForm.controls['productDescription'].reset();
    this.productGridForm.controls['productRatio'].reset();
  }

  triggerScroll(): void {
    this.sharedService.triggerScroll();
  }

  patchFormVals() {
    this.productLossBasedOnSectForm.patchValue({
      mass: this.sectorBasedLossData?.massVolume,
      unit: this.selectedUnit,
      prodSectorData: this.sectorBasedLossData?.sectorIdentifiredName,
      funcUnitMultiplier: this.sectorBasedLossData?.functionalUnitsPerProduct
        ? this.sectorBasedLossData?.functionalUnitsPerProduct
        : 1,
      sectorIdentier: this.selectedIdentifier,
      bulkDensity: this.sectorBasedLossData?.bulkDensity,
      retailVolume: this.sectorBasedLossData?.annualRetailVolume,
    });
  }

  patchFormValsForProduct() {
    this.productLossBasedOnSectForm.patchValue({
      mass: this.productDetailsData?.massVolume,
      unit: this.selectedUnit,
      funcUnitMultiplier: this.productDetailsData?.functionalUnitsPerProduct,
      bulkDensity: this.productDetailsData?.bulkDensity,
      retailVolume: this.productDetailsData?.annualRetailVolume,
    });
    this.isProdMixDisabled = this.productDetailsData?.isProductMixGridEnabled;
  }

  getInitialData() {
    if (this.activatedRoute == 'product-loss') {
      this.isSectorBased = true;
    } else {
      this.isSectorBased = false;
    }
    this.colDefs = this.productLossDataGridService.productMixtureCols();
  }

  routeToProjectSettings() {
    const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
    this.sharedService.accessSideBarData(() => {});
    this.router.navigate([`projects/projects-setting/${customEncode(btoa(encodedValue))}/setting`]);
  }

  refreshProductList() {
    this.projectsFacade.clearProductMixError('');
    this.getProductDetails();
  }

  getSectorData() {
    this.projectsService
      .getProductLossBasedOnSector(this.scenarioId)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        )
      )
      .subscribe(res => {
        this.sectorBasedLossData = res?.data;
        this.unitList = this.sectorBasedLossData?.unit;
        this.getSelectedUnit();
        if (!this.isSectorBased && this.activatedRoute == 'product-loss-sector') {
          this.getSelectedSectorIdentfier();
          this.productLossBasedOnSectForm.controls['sectorIdentier'].setValidators(
            Validators.required
          );
          this.productLossBasedOnSectForm.updateValueAndValidity();
        }
        this.patchFormVals();
      });
  }

  getProductDetails() {
    this.projectsService
      .getProductDetailsForScenario(this.scenarioId)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        )
      )
      .subscribe(res => {
        this.productDetailsData = res?.data;
        this.isProdMixDisabled = this.productDetailsData?.isProductMixGridEnabled;
        this.colDefs = this.productLossDataGridService.productMixtureCols();
        this.unitList = this.productDetailsData?.unit;
        const productList = res.data?.productList.map((item: any) => {
          return {
            ...item,
            disabled: res?.data.productMixList.some((x: any) => x.productId == item.idLong),
          };
        });
        this.productDetailsProductList = productList;
        this.projectsFacade.getProductMixList(res.data);
        this.getSelectedUnit();
        this.patchFormValsForProduct();
      });
  }

  getTitleTextValues(isSector: boolean) {
    if (isSector) {
      this.subTitleText = 'Estimate product with product sector data';
      this.headerData.title = 'Product loss (sector-based)';
    } else if (!isSector && this.activatedRoute == 'product-loss-sector') {
      this.subTitleText = 'Estimate product with product sector data';
      this.headerData.title = 'Product (sector-based)';
    } else {
      this.subTitleText = 'Define the amount of product inside the package';
      this.headerData.title = 'Product';
    }
  }

  async getSelectedUnit() {
    const data =
      this.isSectorBased || (!this.isSectorBased && this.activatedRoute == 'product-loss-sector')
        ? this.sectorBasedLossData
        : this.productDetailsData;
    await data?.unit?.map((item: any) => {
      if (item.selected) {
        return (this.selectedUnit = item);
      }
    });
  }
  async getSelectedSectorIdentfier() {
    const data = this.sectorBasedLossData;
    await data?.sectorIdentifierList?.map((item: any) => {
      if (item.selected) {
        return (this.selectedIdentifier = item);
      }
    });
  }

  saveSectorData() {
    this.submitted = true;
    if (this.productLossBasedOnSectForm.invalid) return;
    let isSecIdentifierReq = !this.isSectorBased && this.activatedRoute == 'product-loss-sector';
    let sectorIdentifierId = isSecIdentifierReq
      ? this.productLossBasedOnSectForm.controls['sectorIdentier']?.value?.id
      : this.sectorBasedLossData?.sectorIdentifierId;
    const payload = {
      packageScenarioId: this.packageScenarioId,
      scenarioId: this.scenarioId,
      sectorIdentifierId: sectorIdentifierId,
      functionalUnitsPerProduct: Number(
        this.productLossBasedOnSectForm.controls['funcUnitMultiplier']?.value
      ),
      massVolume: Number(this.productLossBasedOnSectForm.controls['mass']?.value),
      unitId: this.productLossBasedOnSectForm.controls['unit']?.value?.id,
      isSecIdentifierReq: isSecIdentifierReq,
      bulkDensity: this.productLossBasedOnSectForm.controls['bulkDensity']?.value,
      annualRetailVolume: this.productLossBasedOnSectForm.controls['retailVolume']?.value,
    };
    this.projectsService
      .updateProductLossBasedOnSector(payload)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        )
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  checkValidation(errorStr: any) {
    this.disableSubmit = !!errorStr ? true : false;
  }

  checkEditingStatus(err: any) {
    if (err == 'editingStarted') {
      this.isRowEditable = true;
    } else if (err == 'editingStopped') {
      this.isRowEditable = false;
    }
  }
  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().indexOf(term.toLowerCase()) > -1;
  }

  saveProductData() {
    this.submitted = true;
    if (this.productLossBasedOnSectForm.invalid) return;
    const payload = {
      scenarioId: this.scenarioId,
      packageScenarioId: this.packageScenarioId,
      functionalUnitsPerProduct: Number(
        this.productLossBasedOnSectForm.controls['funcUnitMultiplier']?.value
      ),
      massVolume: Number(this.productLossBasedOnSectForm.controls['mass']?.value),
      unitId: this.productLossBasedOnSectForm.controls['unit']?.value?.id,
      bulkDensity: this.productLossBasedOnSectForm.controls['bulkDensity']?.value,
      annualRetailVolume: this.productLossBasedOnSectForm.controls['retailVolume']?.value,
    };
    this.projectsService
      .addUpdatePackageProductAmountDetails(payload)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        )
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
        !this.isSectorBased && this.activatedRoute == 'product' && this.getProductDetails();
      });
  }

  saveData() {
    if (!this.isSectorBased && this.activatedRoute == 'product-loss-sector') {
      this.saveSectorData();
    } else {
      this.saveProductData();
    }
  }

  backToMaterial() {
    this.activatedRouteProjectId = Number(
      atob(decodeURIComponent(customDecode(location.href.split('/')[6])))
    );
    const valueToEncrypt = `{ "id": ${this.scenarioId}, "packageScenarioId": ${this.packageScenarioId}, "eId": ${this.scenarioId}}`;
    const encryptedValue = encrypt(valueToEncrypt);
    const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
    window.scroll({ top: 0, behavior: 'smooth' });
    this.router.navigate(
      [`projects/projects-setting/${customEncode(btoa(encodedValue))}/material-list`],
      {
        queryParams: { param: encryptedValue },
      }
    );
  }

  onNext(step: string) {
    if (step == 'step22') {
      const valueToEncrypt = `{ "id": ${this.scenarioId}, "packageScenarioId": ${
        this.packageScenarioId
      }, "eId": ${this.eId}, "haveTour": ${true}}`;
      const encryptedValue = encrypt(valueToEncrypt);
      const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
      this.router.navigate(
        [`projects/projects-setting/${customEncode(btoa(encodedValue))}/fill-data-list`],
        { queryParams: { param: encryptedValue } }
      );
    }
  }

  ngOnDestroy() {
    this.prodMixError.unsubscribe();
    this.inlineGridDataSubscription.unsubscribe();
    this.inlineGridDataSubscription.unsubscribe();
    this.inlineEditingProductDeleteData.unsubscribe();
    this.clearDeleteProductData.unsubscribe();
    this.editProductSub.unsubscribe();
    this.projectsFacade.clearProductMixList();
    this.projectsFacade.clearProductMixError('');
  }

  hideShowAddSection() {
    this.hideShowAddSectionFlag = true;
  }
}
